import { RadioOption } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';

export interface getCheckoutDisplaySettingsRuleSubheaderProps {
  displayBudgets: RadioOption;
  orderPolicyAcceptanceRequired: RadioOption;
  isOrderPolicyVisible: boolean;
}

const messages = new Map([
  [
    `${RadioOption.YES}_${RadioOption.YES}`,
    'Show credit balance and ordering policy',
  ],
  [
    `${RadioOption.YES}_${RadioOption.NO}`,
    'Show credit balance, don’t show ordering policy',
  ],
  [
    `${RadioOption.NO}_${RadioOption.YES}`,
    'Don’t show credit balance, show ordering policy',
  ],
  [
    `${RadioOption.NO}_${RadioOption.NO}`,
    'Don’t show credit balance or ordering policy',
  ],
]);

export function getCheckoutDisplaySettingsRuleSubheader({
  displayBudgets,
  orderPolicyAcceptanceRequired,
  isOrderPolicyVisible,
}: getCheckoutDisplaySettingsRuleSubheaderProps): string {
  const key = `${displayBudgets}_${orderPolicyAcceptanceRequired}`;

  if (!isOrderPolicyVisible) {
    return displayBudgets === RadioOption.YES
      ? 'Show credit balance'
      : 'Don’t show credit balance';
  }

  return messages.get(key);
}
